export default function About() {
  return (
    <section id="about" className="py-32 bg-gradient-to-b from-teal-50 to-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 flex items-center justify-center bg-teal-500 rounded-full">
            <i className="ri-global-line text-4xl text-white"></i>
          </div>
        </div>

        <p className="text-teal-600 text-sm font-semibold uppercase tracking-wider mb-6">
          Why Choose Us
        </p>

        <h2 className="text-4xl font-bold text-gray-900 leading-relaxed mb-8">
          10년 이상의 외국계 실무 경험을 바탕으로,
          <br />
          실제로 효과가 있는 전략만을 공유합니다.
          <br />
          영어 이메일 작성부터 면접 준비, 커리어 전환까지 -
          <br />
          당신의 성공이 우리의 목표입니다 ✨
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
              <i className="ri-user-star-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">실무 중심</h3>
            <p className="text-gray-600 text-sm">
              현장에서 검증된 실질적인 전략과 노하우
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
              <i className="ri-team-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">1:1 맞춤</h3>
            <p className="text-gray-600 text-sm">
              개인별 상황에 맞는 맞춤형 컨설팅
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
              <i className="ri-trophy-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">검증된 성과</h3>
            <p className="text-gray-600 text-sm">
              500명 이상의 성공적인 커리어 전환 지원
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
